import { render, staticRenderFns } from "./PlaceholderConfig.vue?vue&type=template&id=1ee33615&scoped=true"
import script from "./PlaceholderConfig.vue?vue&type=script&lang=js"
export * from "./PlaceholderConfig.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderConfig.vue?vue&type=style&index=0&id=1ee33615&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee33615",
  null
  
)

export default component.exports